import React, {useEffect, useState} from "react";
import {getDisplayTime, getReceiptRequest} from "./paymentFunctions";
import { getCurrency } from "../config/utils";
import Dialog from '@mui/material/Dialog';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid2 from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import Replay from "@mui/icons-material/Replay";
import Typography from '@mui/material/Typography';
import {useSxStyles as sx} from "../styles/sxStyles";
import API from "../http/API";
import {Alert, AlertTitle} from "@mui/material";
import {useRequestUrl, useAuthToken} from "../context/contextHooks";
import {Download} from "@mui/icons-material";


const PaymentDetails = (props) => {
    const paymentRequest = props.paymentRequest;
    const paymentResult = props.paymentResult;
    const openReceipt = props.openReceipt;
    const setOpenReceipt = props.setOpenReceipt;
    const [isDownloading, setIsDownloading] = useState(false);
    const [fileResponse, setFileResponse] = useState(null);
    const [requestUrl,] = useRequestUrl();
    const [authToken,] = useAuthToken();
    const [error, setError] = useState(null);


    const handleClose = () => {
        setOpenReceipt(false);
        setIsDownloading(false);
        setError(null);
    }

    const handleDownload = () => {
        setError(null);
        if (!isDownloading) {
            setIsDownloading(true);
            const request = getReceiptRequest(paymentRequest, paymentResult);
            API.postForFile(`${requestUrl}/getReceiptPdf`, request, 'getReceipt', authToken, setFileResponse);
        }
    };

    const scrollToAlert = () => {
        window.scrollTo(0, 40);
    };

    useEffect(() => {
        if (isDownloading && fileResponse) {
            if (fileResponse.type === 'application/json') {
                const blb = new Blob([fileResponse], {type: "application/json"});
                const reader = new FileReader();
                reader.onload = function () {
                    const text = reader.result;
                    const actionResponse = JSON.parse(text);
                    setError(actionResponse.errorMessage);
                    scrollToAlert();
                }
                reader.readAsText(blb);
            } else {
                const file = new Blob([fileResponse], {type: "application/pdf"});
                file.name = 'paymentsReport.pdf'
                const fileUrl = window.URL.createObjectURL(file);
                let link = document.createElement('a');
                link.href = fileUrl;
                link.download = 'CitePayReceipt.pdf';
                link.click();
                setTimeout(() => {
                    window.URL.revokeObjectURL(fileUrl);
                }, 100);
            }
            setIsDownloading(false);
        }
    }, [fileResponse])

    return (
        (<Dialog
            disableEscapeKeyDown
            fullWidth
            maxWidth='sm'
            open={openReceipt}
            onClose={handleClose}
            sx={sx.dialog}
            aria-labelledby="View payment receipt"
        >
            <DialogTitle style={{paddingBottom: '0'}}>
                <Typography variant="h6" component='h1' color='primary'>Payment Details</Typography>
            </DialogTitle>
            { error &&
                <Alert severity='error' sx={{marginTop: '1rem', textAlign: 'left'}}>
                    <AlertTitle>Error!</AlertTitle>
                    {error}
                </Alert>
            }
            <DialogContent dividers>
                <Grid2 container spacing={2} alignItems='top' >
                    <Grid2 size={5}>
                        <Typography component='span' sx={sx.displayLabel}>Time: </Typography>
                    </Grid2>
                    <Grid2 size={7}>
                        <Typography component='span' color='primary' sx={sx.displayValue}>{getDisplayTime(paymentResult.paymentTime)}</Typography>
                    </Grid2>
                    <Grid2 size={5}>
                        <Typography component='span' sx={sx.displayLabel}>Transaction ID: </Typography>
                    </Grid2>
                    <Grid2 size={7}>
                        <Typography component='span' color='primary' sx={sx.displayValue}>{paymentResult.transactionId}</Typography>
                    </Grid2>
                    <Grid2 size={5}>
                        <Typography component='span' sx={sx.displayLabel}>Payment Amount: </Typography>
                    </Grid2>
                    <Grid2 size={7}>
                        <Typography component='span' color='primary' sx={sx.displayValue}>{getCurrency(paymentRequest.totalAmount)}</Typography>
                    </Grid2>
                    { paymentResult.authCode &&
                        <>
                            <Grid2 size={5}>
                                <Typography component='span' sx={sx.displayLabel}>Approval Code: </Typography>
                            </Grid2>
                            <Grid2 size={7}>
                                <Typography component='span' color='primary' sx={sx.displayValue}>{paymentResult.authCode}</Typography>
                            </Grid2>
                        </>
                    }
                    { paymentResult.cardType &&
                        <>
                            <Grid2 size={5}>
                                <Typography component='span' sx={sx.displayLabel}>Card Type: </Typography>
                            </Grid2>
                            <Grid2 size={7}>
                                <Typography component='span' color='primary' sx={sx.displayValue}>{paymentResult.cardType}</Typography>
                            </Grid2>
                        </>
                    }
                    { paymentResult.cardNumberMasked &&
                        <>
                            <Grid2 size={5}>
                                <Typography component='span' sx={sx.displayLabel}>Account Number: </Typography>
                            </Grid2>
                            <Grid2 size={7}>
                                <Typography component='span' color='primary' sx={sx.displayValue}>{paymentResult.cardNumberMasked}</Typography>
                            </Grid2>
                        </>
                    }
                    <Grid2 size={5}>
                        <Typography component='span' sx={sx.displayLabel}>Description: </Typography>
                    </Grid2>
                    <Grid2 size={7}>
                        <Typography component='span' sx={sx.displayValue}>{paymentRequest.paymentDescription}</Typography>
                    </Grid2>
                </Grid2>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined"
                        color="primary"
                        startIcon={<Replay/>}
                        sx={sx.button}
                        onClick={handleClose}
                >
                    Close
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<Download/>}
                    sx={sx.button}
                    onClick={handleDownload}
                    disabled={isDownloading}
                >
                    {isDownloading ? "Downloading..." : "Download"}
                </Button>
            </DialogActions>
        </Dialog>)
    );
}

export default PaymentDetails;
